
CheckoutV2.Cart.Item = function( checkout, cart ) {
	var item = this;

	
	this.moreInfoShown = false;
	this.moreInfoRequest;

	this.init = function() {
	};

  this.add = function(response, poETA) {
        var data        = response.item,
            infos       = response.infos,
            suggestions = response.suggestions,
            options     = response.kitContents || [];


		item.options = options;
		item.data = data;
        item.cartItemKey = data.cartItemKey;
		item.productID = data.productID;

		item.productPath = data.productPath;

		cart.items[item.cartItemKey] = item;
		
		// Add any product suggestions to the list
		if(checkout.config.suggestions && suggestions && suggestions.length) {
			for(var i = 0; i < suggestions.length; i ++) {
				checkout.suggestions.addItem(suggestions[i]);
			}
		}
  
		for (var k in item.data) {
			
			// needed because shipETA is not set in time (via cart.setShipDate) for shipQuote call
			if (k == 'ETA') {
				//console.log('item',item.data['stockStatus'],item.data[k]);
				if (item.data['stockStatus'].indexOf("Back Ordered") < 0) { // && item.data['stockStatus'].indexOf("Direct Ship") < 0
					if (item.data[k] > checkout.cart.shipETA)
						checkout.cart.shipETA = item.data[k];
				}
			}
			if (k == 'po_ETA') {
				//console.log('item',item.data['po_stockStatus'],item.data[k]);
				if (item.data['po_stockStatus'].indexOf("Back Ordered") < 0) { // && item.data['stockStatus'].indexOf("Direct Ship") < 0
					if (item.data[k] > checkout.cart.po_shipETA)
						checkout.cart.po_shipETA = item.data[k];
				}
			}
			
			//console.log(k);
			if (k == 'mainImage') {
            	var prodImgSize = pointsBreak.getWidth() > 480 ? checkout.config.prodImgSize.small : 300;
            	item.data.image = (prodImgSize !== undefined) ? CDNproduct + '/' + item.data.mainImage + '_x'+prodImgSize+'.jpg' : CDNpath + '/img/bg_no-image_100x75.jpg';
			}
		}
		
		item.setPrice(item.data.unitprice, item.data.price_retail, item.data.availablePricing);
		item.updatePricingLevels();
		
		//console.log(item);
		// handle review cart items

        var po_data = JSON.parse( JSON.stringify( item.data ));
		po_data['stockStatus'] = po_data['po_stockStatus'] || po_data.stockStatus;
		po_data['stockStatusIcon'] = po_data['po_stockStatusIcon'] || po_data.stockStatusIcon;
		po_data['stockStatusLong'] = po_data['po_stockStatusLong'] || po_data.stockStatusLong;
		po_data['ETA'] = po_data['po_ETA'] || po_data.ETA;
		if (poETA) {
			var item_data = item.data;
			item.data = po_data;
		}

		cart.$itemContainer.append(
            Jemplate.process('includes/partials/productTile.html', {
                section: 'cart',
                item: item,
				CDNstatic: CDNpath,
				CDNbrandLogo: CDNbrandLogo,
                globals: {
                    employeeLoggedIn: checkout.config.user,
                    productAdminEditURL: checkout.config.productAdminEditURL,
					cartItemProdIDKey: checkout.config.cartItemProdIDKey
                }
            })
        );
		cart.$reviewItemContainer.append(
            Jemplate.process('includes/partials/productTile.html', {
                section: 'review',
                item: item,
				CDNstatic: CDNpath,
				CDNbrandLogo: CDNbrandLogo,
                globals: {
                    employeeLoggedIn: checkout.config.user,
                    productAdminEditURL: checkout.config.productAdminEditURL,
					cartItemProdIDKey: checkout.config.cartItemProdIDKey
                }
            })
        );

		if (poETA) {
			var item_data = item.data;
			item.data = item_data;
		}
		
        if (infos && infos.length) {
            item.info(infos.join('<br />'));
        } else {
            item.info(false);
        }
        
        if (checkout.config.promoCodeEnabled && item.data.promoCode) {
            checkout.cart.promos.applyCodeManual(item.data.promoCode);
        }
	};

	this.changeQty = function(qty) {

		if (!qty) {
			cart.toggleStepControls(false);
			$('#cart-item-'+item.data.cartItemKey).find('.confirm-remove').show();
			return;
		}

		if (qty == item.data.qty) {
			$('#cart-item-'+item.data.cartItemKey).find('.cart-item-qty').val(item.data.qty);
			$('#cart-item-'+item.data.cartItemKey + '-review').find('.cart-item-qty').val(item.data.qty);
			return;
		}

		item.loading('Updating Item Quantity');
		cart.totals.loading('Calculating Totals');

		var shipping_country = checkout.session.get('shipping.country') || 'US';
		var usePoETA = (shipping_country !== 'US');
		checkout.remote.call({
			'data': {
				'step': 'cart',
				'action': 'updateQty',
				'cartItemKey': item.cartItemKey,
				'productID': item.productID,
				'qty': qty,
				'usePoETA': usePoETA,
				'pricing': ($('#cart-item-'+item.data.cartItemKey).find('.cart-item-price-edit select').val() || 'retail'),
				'code': (checkout.config.promoCodeEnabled ? cart.promos.getAppliedCode() : '')
			}
		})
		.done(function(response) {
			item.error(false);
            if(response.notice) cart.error(response.notice);

			var qtyChanged = false;
			var reloadCart = false;
			if (response.data.qty != item.data.qty)
				qtyChanged = true;

			if (checkout.config.promoCodeEnabled && response.info && !response.info.valid) {
					reloadCart = true;
					response.info.refreshCart = false; // below will reload so bypass in promo code
					cart.promos.validateCode(response.info);
			}

			item.update(response);

			if (reloadCart) {
				cart.checkItems( true, qtyChanged, usePoETA );
			} else {
				if (qtyChanged) {
					cart.totals.calc(true);
				} else {
					cart.totals.update('cart');
				}
			}
		})
		.fail(function(request) {
			item.error('Failed to Update Item Quantity');
			item.warning(false);
		})
		.always(function() {
			item.loading(false);
			$('#cart-item-'+item.data.cartItemKey).find('.cart-item-qty').focus();
		});
	};

	this.confirmRemove = function(remove) {
		if (remove)
			item.remove();
		else {

			if (checkout.currentStepName() == 'cart')
				cart.toggleStepControls();

			item.changeQty(item.data.qty);
			$('#cart-item-'+item.data.cartItemKey).find('.confirm-remove').hide();
			$('#cart-item-'+item.data.cartItemKey).find('.cart-item-qty').focus();
		}
	};

	this.update = function(response, infos, poETA, skipStep) {
		var data = response.data || response.item; // we now use item.update from Cart (response.item) and Cart.Item (response.data)


		if (!infos) {
			infos = [];

			if (data.stockStatus != item.data.stockStatus)
				infos.push('The availability of this item has changed due to quantity on your order');

			if (data.unitprice != item.unitprice)
				infos.push('Price has changed');
		}

		item.data = data;

		$('#cart-item-'+item.data.cartItemKey).find('.cart-item-qty').val(item.data.qty);

		/*  TODO: needed ???
		item.$row.find('.cart-item-stockStatusIcon')
			.attr('class', 'cart-item-stockStatusIcon')
			.addClass('status-'+item.data.stockStatusIcon);

		if (item.data.stockStatusIcon === '1')
			item.$row.find('.cart-item-stockStatus').addClass('redtxt').html(item.data.stockStatus);
		else
			item.$row.find('.cart-item-stockStatus').removeClass('redtxt').html(item.data.stockStatus);
		*/

		item.updatePricingLevels();
		item.setPrice(data.unitprice, data.price_retail, data.availablePricing);
		
        var prodImgSize = pointsBreak.getWidth() > 480 ? checkout.config.prodImgSize.small : 300;
        item.data.image = (prodImgSize !== undefined) ? CDNproduct + '/' + item.data.mainImage + '_x'+prodImgSize+'.jpg' : CDNpath + '/img/bg_no-image_100x75.jpg';

		
        var po_data = JSON.parse( JSON.stringify( item.data ));
		po_data['stockStatus'] = po_data['po_stockStatus'] || po_data.stockStatus;
		po_data['stockStatusIcon'] = po_data['po_stockStatusIcon'] || po_data.stockStatusIcon;
		po_data['stockStatusLong'] = po_data['po_stockStatusLong'] || po_data.stockStatusLong;
		po_data['ETA'] = po_data['po_ETA'] || po_data.ETA;
		if (poETA) {
			var item_data = item.data;
			item.data = po_data;
		}

		$('#cart-item-'+item.data.cartItemKey).replaceWith(
			Jemplate.process( 'includes/partials/productTile.html',
				{section: 'cart', item: item, CDNstatic: CDNpath, CDNbrandLogo: CDNbrandLogo,
					globals: {
						employeeLoggedIn: checkout.config.user,
						productAdminEditURL: checkout.config.productAdminEditURL,
						cartItemProdIDKey: checkout.config.cartItemProdIDKey
					}
				}
			)
		);
		$('#cart-item-'+item.data.cartItemKey + '-review').replaceWith(
			Jemplate.process( 'includes/partials/productTile.html',
				{section: 'review', item: item, CDNstatic: CDNpath, CDNbrandLogo: CDNbrandLogo,
					globals: {
						employeeLoggedIn: checkout.config.user,
						productAdminEditURL: checkout.config.productAdminEditURL,
						cartItemProdIDKey: checkout.config.cartItemProdIDKey
					}
				}
			)
		);

		if (poETA) {
			item.data = item_data;
		}
		
		if (infos.length)
			item.info(infos.join('<br />'), skipStep);
		else
			item.info(false, true);
		
		if (!($.isArray(response.warning)) && response.warning) { // we now use item.update from Cart and Cart.Item, ignore arrays since those are cart level and already handled
			item.warning(response.warning);
		}
		
		cart.setShipDate(poETA); // just in case something changed

        cart.sendToListrak();
	};

	this.updatePricingLevels = function() {
		
		var pricing = item.data.availablePricing,
			pricingLevel = $('#cart-item-'+item.data.cartItemKey).find('.cart-item-price-edit select').val(), //item.$selectPrice.val(),
			options = [];
			
		item.displayPrice = 1;
		item.editPrice = 1;
		item.selectPrice = 1;
//
//      The following test is replaced to take care of 'LimitedQty' and 'Retail' in
//      the pricing structure.  'Retail' would show to the customer.
//
//		if (
//			Object.keys(pricing).length <= 1
//			&& ('retail' in pricing)
//
//      Make sure 'Retail' is the only type of pricing in the structure
//
		if (('retail' in pricing) &&
				(!('group' in pricing) &&
                 !('employee' in pricing) &&
				 !('cost' in pricing)))
		{
			//item.$editPriceWrap.hide();
			//item.$selectPrice.empty();
			item.editPrice = 0;
			item.selectPrice = 0;
			return;
		}

		if ('retail' in pricing) {

			options.push({
				value: 'retail', text: 'Retail: '+pricing.retail
			});

			if (
				!pricingLevel
				&& item.unitprice == pricing.retail
			)
				pricingLevel = 'retail';
		}

		if ('group' in pricing) {
			for (var group in pricing.group) {
				options.push({
					value: 'group'+group,
					text: ((group == 'Fixed') ? '' : 'Group ') +group+': '
						+ pricing.group[group]
						+ ' ('+ item.getDiscountPercent(pricing.retail, pricing.group[group]) + ')'
				});

				if (
					!pricingLevel
					&& item.unitprice == pricing.group[group]
				)
					pricingLevel = 'group'+group;
			}
		}

		if ('employee' in pricing) {
			options.push({
				value: 'employee',
				text: 'Employee: '+pricing.employee+' ('
					+ item.getDiscountPercent(pricing.retail, pricing.employee)
					+ ')'
			});

			if (
				!pricingLevel
				&& item.unitprice == pricing.employee
			)
				pricingLevel = 'employee';
		}

		if ('cost' in pricing) {
			options.push({
				value: 'cost',
				text: 'Cost: '+pricing.cost+' ('
					+ item.getDiscountPercent(pricing.retail, pricing.cost)
					+ ')'
			});

			if (
				!pricingLevel
				&& item.unitprice == pricing.cost
			)
				pricingLevel = 'cost';
		}

		if (
			!pricingLevel
			|| pricingLevel == 'manual'
		) {
			options.push({ value: 'manual', text: 'Manual Entry'});
			pricingLevel = 'manual'
		}

		//item.$selectPrice
		//	.empty()
		//	.html(options.join("\n"))
		//	.val(pricingLevel);
		item.pricingOptions = options;
		item.pricingLevel = pricingLevel;

		if (
			Object.keys(pricing).length <= 1
			&& ('manual' in pricing)
		) {
			//item.$selectPrice.hide();
			item.selectPrice = 0;
			return;
			
		} else {
			//item.$selectPrice.show();
			item.selectPrice = 1;
		}

		if ('manual' in pricing && pricing.manual) {
			//item.$displayPrice.hide();
			//item.$editPrice.show();
			item.displayPrice = 0;
			item.editPrice = 1;
		} else {
			//item.$displayPrice.show();
			//item.$editPrice.hide();
			item.displayPrice = 1;
			item.editPrice = 1; // TODO: should be 0 based on old logic but you can always manually override price ????
		}

		//item.$editPriceWrap.show();
	};

	this.getDiscountPercent = function(retail, price) {
		return (((1 - (price / retail)) * -100).toFixed(1))+'%';
	};

	this.changePrice = function(changeMethod) {
		var pricing = item.data.availablePricing,
			pricingLevel = $('#cart-item-'+item.data.cartItemKey).find('.cart-item-price-edit select').val(),
			newPrice = 0,
			$manualOption = $('#cart-item-'+item.data.cartItemKey).find('.cart-item-price-edit select option[value=manual]');

		if (changeMethod == 'input') {

			newPrice = $('#cart-item-'+item.data.cartItemKey).find('.cart-item-price-edit input').val();

			if (!$manualOption.length) {
				$('#cart-item-'+item.data.cartItemKey).find('.cart-item-price-edit select').append(
					'<option value="manual">Manual Entry</option>'
				);
			}
			
			$('#cart-item-'+item.data.cartItemKey).find('.cart-item-price-edit select').val('manual');

		} else {

			newPrice = pricing[pricingLevel];

			if ($manualOption.length)
				$manualOption.remove();

		}

		if (
			changeMethod == 'select'
			&& pricingLevel.substr(0, 5) == 'group'
		)
			newPrice = pricing.group[pricingLevel.substr(5)];

		newPrice = (parseFloat(newPrice) || 0).toMoney();

		if (item.unitprice != parseFloat(newPrice)) {

			item.loading('Updating Item Price');
			cart.totals.loading('Calculating Totals');

			checkout.remote.call({
				'data': {
					'step': 'cart',
					'action': 'updatePrice',
                    'cartItemKey': item.cartItemKey,
					'productID': item.productID,
					'qty': item.data.qty,
					'price': newPrice
				}
			})
				.done(function(response) {
					item.error(false);

					var valueChanged = false;
					if (response.data.unitprice != newPrice)
						valueChanged = true;
					
					item.update(response);

					if (valueChanged)
						cart.totals.calc(true);
					else
						cart.totals.update('cart');
					})
				.fail(function(request) {
					item.error('Failed to Update Item Price');
				})
				.always(function() {
					item.loading(false);
				});
		}
	};

	this.setPrice = function(price, retail, availablePricing) {
		item.unitprice = parseFloat(price).toMoney();
		
		item.extendPrice();

		price  = parseFloat(price);
        retail = parseFloat(retail);

        if(price < retail) item.saleDiscount(price, retail, availablePricing);
	};

	this.extendPrice = function() {
		item.data.extendPrice =	(item.data.qty * item.unitprice).toMoney();
	};

	this.saleDiscount = function(price, retail, availablePricing) {
        var discountPercentage = (retail - price) / retail * 100;
        // round the discount to the nearest percent
        discountPercentage = parseInt(discountPercentage + 0.5, 10);

        item.data.pricecut = retail.toMoney();

		item.data.promoDiscount = parseFloat(item.data.promoDiscount || 0);

        // Do not show the on sale text if this is a wholesale/manual price
        if (
          ( availablePricing && price != availablePricing.retail ) &&
          !item.data.promoDiscount
        ) {
            return;
		}
		
		item.data.labels = [];
		
		if ( price + item.data.promoDiscount < retail) {
			item.data.labels.push("Sale");
		}

		if (item.data.promoDiscount) {
			item.data.labels.push("Promo: " + item.data.promoCode);
		}
		
		if ( !(availablePricing.limitedQty) && discountPercentage >= 10) {
            item.data.discountPercentage = discountPercentage;
        }
    };

	this.remove = function() {

		if (!item.productID) {
			$('#cart-item-'+item.data.cartItemKey).remove();
			$('#cart-item-'+item.data.cartItemKey + '-review').remove();
			return;
		}

		item.loading('Removing Item');
		cart.totals.loading('Calculating Totals');

		var shipping_country = checkout.session.get('shipping.country') || 'US';
		var usePoETA = (shipping_country !== 'US');
		checkout.remote.call({
			'data': {
				'step': 'cart',
				'action': 'remove',
				'cartItemKey' : item.cartItemKey,
				'code': (checkout.config.promoCodeEnabled ? cart.promos.getAppliedCode() : '')
			}
		})
			.done(function(response) {
				//item.$row.fadeOut(500, function() {
					$('#cart-item-'+item.data.cartItemKey).remove();
					$('#cart-item-'+item.data.cartItemKey + '-review').remove();
					delete(cart.items[item.cartItemKey]);
					if (checkout.config.promoCodeEnabled && response.info && response.info.valid) {
							cart.promos.validateCode(response.info);
					}
					cart.checkItems( true, true, usePoETA );
					if ( checkout.config.promoCodeEnabled && Object.keys( cart.items ).length < 1 && response.info ) { // remove any promo notifications on empty cart
						//cart.promos.clearCodeResult();
		        cart.promos.clearNotifications();
					}
          cart.toggleHasContents( Object.keys( cart.items ).length > 0 );
					cart.setShipDate();
					cart.totals.updateNumItems();
                    cart.sendToListrak();
				//});
			})
			.fail(function(request) {
				var errorMsg = checkout.remote.getErrorMsg(request);

				item.loading(false);

				if (errorMsg)
					alert('Removing Cart Item Failed: ' + errorMsg);
			});
	};

	this.toggleMoreInfo = function() {

		if (item.moreInfoShown) {

			if (item.moreInfoRequest)
				item.moreInfoRequest.abort();

			
			$('#cart-item-'+item.data.cartItemKey).find('.moreInfo')
				.removeClass('btn-danger')
				.addClass('btn-success')

			$('#cart-item-'+item.data.cartItemKey).find('.moreInfo i')
				.removeClass('fa-minus-circle')
				.addClass('fa-plus-circle');
				
			$('#cart-item-'+item.data.cartItemKey).find('.js-more-info-txt').text('More Info');

			$('#cart-item-'+item.data.cartItemKey).find('.cart-item-moreinfo').remove();
				
			item.moreInfoShown = false;
		} else {

			if (item.moreInfoRequest)
				item.moreInfoRequest.abort();
			
			$('#cart-item-'+item.data.cartItemKey).find('.moreInfo')
				.removeClass('btn-success')
				.addClass('btn-danger');
			
			$('#cart-item-'+item.data.cartItemKey).find('.moreInfo i')
				.removeClass('fa-plus-circle')
				.addClass('fa-minus-circle');
				
			$('#cart-item-'+item.data.cartItemKey).find('.js-more-info-txt').text('Less Info');

			item.moreInfoRequest = checkout.remote.call({
				'data': {
					'step': 'cart',
					'action': 'getMoreInfo',
					'productID': item.productID,
					'qty': item.data.qty,
					'pdkStr': cart.items[item.cartItemKey].data.pdk
				}
			})
			.done(function(response) {

				var rows = [];

				$.each(response.data, function(i, product) {
					rows.push(product);
				});
				
				$('#cart-item-'+item.data.cartItemKey).append(Jemplate.process('includes/partials/product_more_info.html', {products: rows, productAdminEditURL: checkout.config.productAdminEditURL}));

				if (!(checkout.config.isEndeca)) {
					$('#cart-item-'+item.data.cartItemKey).find('.moreInfo')
						.removeClass('btn-success')
						.addClass('btn-danger');
				}
				
				$('#cart-item-'+item.data.cartItemKey).find('.moreInfo i')
					.removeClass('fa-plus-circle')
					.addClass('fa-minus-circle');

				item.moreInfoShown = true;

			})
			.fail(function(request) {
				if (!(checkout.config.isEndeca)) {
					$('#cart-item-'+item.data.cartItemKey).find('.moreInfo')
						.removeClass('btn-danger')
						.addClass('btn-success');
				}

				$('#cart-item-'+item.data.cartItemKey).find('.moreInfo i')
					.removeClass('fa-minus-circle')
					.addClass('fa-plus-circle');
				alert('Error loading more info');
			});

		}
	};

	this.loading = function(loadingMsg) {
		if (loadingMsg) {
			$('#cart-item-'+item.data.cartItemKey).find('.loading-overlay .msg-text').html(loadingMsg);
			$('#cart-item-'+item.data.cartItemKey).find('.loading-overlay').show();
			//checkout.alignMiddle($('#cart-item-'+item.data.cartItemKey).find('.loading-overlay').find('.msg'), $('#cart-item-'+item.data.cartItemKey).find('.loading-overlay'));
			this.clearMessages();
		} else
			$('#cart-item-'+item.data.cartItemKey).find('.loading-overlay').hide();
	};
	
	this.error = function(errorMsg) {
		if (errorMsg) {
			$('#cart-item-'+item.data.cartItemKey).find('.cart-item-error .msg-text').html(errorMsg);
			$('#cart-item-'+item.data.cartItemKey).find('.cart-item-error').show();
            checkout.nextStep( false, 0 );
		} else {
			$('#cart-item-'+item.data.cartItemKey).find('.cart-item-error').hide();
			$('#cart-item-'+item.data.cartItemKey).find('.cart-item-error .msg-text').html('');
		}
	};

	this.warning = function(warningMsg) {
		if (warningMsg) {
			$('#cart-item-'+item.data.cartItemKey).find('.cart-item-warning .msg-text').html(warningMsg);
			$('#cart-item-'+item.data.cartItemKey).find('.cart-item-warning').show();
            checkout.nextStep( false, 0 );
		} else {
			$('#cart-item-'+item.data.cartItemKey).find('.cart-item-warning').hide();
			$('#cart-item-'+item.data.cartItemKey).find('.cart-item-warning .msg-text').html('');
		}
	};

	this.info = function(infoMsg, skipStep) {
		if (infoMsg) {
			$('#cart-item-'+item.data.cartItemKey).find('.cart-item-info .msg-text').html(infoMsg);
			$('#cart-item-'+item.data.cartItemKey).find('.cart-item-info').show();
			if (!skipStep)
            	checkout.nextStep( false, 0 );
		} else {
			$('#cart-item-'+item.data.cartItemKey).find('.cart-item-info').hide();
			$('#cart-item-'+item.data.cartItemKey).find('.cart-item-info .msg-text').html('');
		}
	};
	
	this.clearMessages = function() {
		this.error();
		this.warning();
		this.info();
	}

	this.init();
	
};
